import { render, staticRenderFns } from "./UploadLoading.vue?vue&type=template&id=0a21d0e5&scoped=true&"
import script from "./UploadLoading.vue?vue&type=script&lang=js&"
export * from "./UploadLoading.vue?vue&type=script&lang=js&"
import style0 from "./UploadLoading.vue?vue&type=style&index=0&id=0a21d0e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a21d0e5",
  null
  
)

export default component.exports